module.exports = __webpack_public_path__ + "img/RBS04_3_loading.155ecff3.jpg";